module.exports = __webpack_public_path__ + "files/4db6733afb4ea52aeca59250ea8e2eff.png";